module.exports = __webpack_public_path__ + "static/media/image_35.8c868505.png";